'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = require('react');
var ReactDOM = require('react-dom');
var _ = require('lodash');
var compose = require('../hoc/compose');
var arrowIcon = require('./arrowDown.svg.js');
var KEYS = require('../constants/keyCodes');
var STOP_PROPAGATION_KEYS = _.pick(KEYS, ['BACKSPACE', 'LEFT', 'UP', 'RIGHT', 'DOWN', 'ENTER', 'SPACE', 'ESC', 'Z']);

var getSelectedContentProps = function getSelectedContentProps(props) {
    return {
        key: 'selected',
        className: 'selected-content' + (props.hasArrowIcon ? ' has-arrow-icon' : '')
    };
};

var cloneChildrenIfNeeded = function cloneChildrenIfNeeded(props) {
    return props.isVisible === null || !React.isValidElement(props.children) ? props.children : React.cloneElement(props.children, {
        shouldTranslate: props.shouldTranslate,
        isSelectedElement: props.isSelectedElement,
        isVisible: props.isVisible,
        wasVisible: props.wasVisible
    }, props.children.props.children);
};

var getChildren = function getChildren(props) {
    return React.createElement('div', getSelectedContentProps(props), _.isString(props.children) ? props.translateIfNeeded(props.children) : cloneChildrenIfNeeded(props));
};

var getArrowIfNeeded = function getArrowIfNeeded(props) {
    return props.hasArrowIcon ? React.createElement('span', {
        className: 'symbol-arrow-down',
        key: 'arrow'
    }, React.createElement(arrowIcon)) : null;
};

var Option = function (_React$Component) {
    _inherits(Option, _React$Component);

    function Option() {
        _classCallCheck(this, Option);

        return _possibleConstructorReturn(this, (Option.__proto__ || Object.getPrototypeOf(Option)).apply(this, arguments));
    }

    _createClass(Option, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.selected && this.props.onSelectedMount) {
                this.props.onSelectedMount(this);
            }
            if (this.props.active && this.props.onActive) {
                this.props.onActive(this);
            }
            if (this.props.onMount) {
                this.props.onMount(this);
            }
        }
    }, {
        key: 'componentWillUpdate',
        value: function componentWillUpdate(nextProps) {
            if (nextProps.active && !this.props.active && this.props.onActive) {
                this.props.onActive(this);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.props.active) {
                this.props.onActive(null);
            }
            if (this.props.selected && this.props.onSelectedMount) {
                this.props.onSelectedMount(null);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var props = this.props;
            var onMouseEnter = props.onMouseEnter;

            var onClick = function onClick() {
                return props.disabled ? _.noop() : props.onClick(props.value);
            };
            var className = ['control-dropdown-option', props.selected ? 'selected' : '', props.disabled ? 'disabled' : '', props.active ? 'active' : ''].join(' ');

            return React.createElement('div', {
                className: className,
                onClick: onClick,
                onMouseEnter: onMouseEnter,
                'data-aid': props.automationId
            }, getChildren(props));
        }
    }]);

    return Option;
}(React.Component);

var Selected = function Selected(props) {
    return React.createElement('div', {
        key: props.key,
        className: 'selected-container'
    }, [getChildren(_.assign({}, props, { isSelectedElement: true })), getArrowIfNeeded(props)]);
};

var lastSelection = { start: null, end: null };
var pendingBackspace = false;

var isUndoRedo = function isUndoRedo(e) {
    return (e.ctrlKey || e.metaKey) && e.keyCode === KEYS.Z;
};

var onSearchBoxKeyDown = function onSearchBoxKeyDown(e) {
    if (e.keyCode === KEYS.BACKSPACE) {
        var _e$target = e.target,
            value = _e$target.value,
            selectionStart = _e$target.selectionStart,
            selectionEnd = _e$target.selectionEnd;

        if (value !== '') {
            pendingBackspace = true;
        }
        if (_.isNumber(selectionStart) || _.isNumber(selectionEnd)) {
            lastSelection.start = selectionStart;
            lastSelection.end = selectionEnd;
        }
    } else if (e.keyCode === KEYS.UP || e.keyCode === KEYS.DOWN || isUndoRedo(e)) {
        e.preventDefault();
        e.stopPropagation();
    } else if (_(STOP_PROPAGATION_KEYS).values().includes(e.keyCode)) {
        e.stopPropagation();
    }
};

var SearchBox = function (_React$Component2) {
    _inherits(SearchBox, _React$Component2);

    function SearchBox() {
        _classCallCheck(this, SearchBox);

        return _possibleConstructorReturn(this, (SearchBox.__proto__ || Object.getPrototypeOf(SearchBox)).apply(this, arguments));
    }

    _createClass(SearchBox, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this3 = this;

            this.props.registerInputToAllowEvents(this.input);
            this.props.onChange(this.props.selectedValue, function () {
                var inputElement = ReactDOM.findDOMNode(_this3.input);
                if (inputElement) {
                    inputElement.focus();
                    inputElement.select();
                    inputElement.addEventListener('keydown', onSearchBoxKeyDown);
                }
            });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.props.registerInputToAllowEvents(null);
            var inputElement = ReactDOM.findDOMNode(this.input);
            if (inputElement) {
                inputElement.removeEventListener('keydown', onSearchBoxKeyDown);
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            var searchTerm = this.props.searchTerm.toLowerCase();
            var value = this.props.value.toLowerCase();

            if (_.startsWith(value, searchTerm)) {
                var inputElement = ReactDOM.findDOMNode(this.input);
                var selectionSubstring = value.replace(searchTerm, '');

                if (inputElement) {
                    var selectionStart = value.indexOf(selectionSubstring);
                    if (selectionStart > 0) {
                        inputElement.selectionStart = selectionStart;
                    }
                }
            }
        }
    }, {
        key: 'onChange',
        value: function onChange(e) {
            var value = e.target.value;
            var selectionEnd = e.target.selectionEnd;

            var lastSelectionLength = lastSelection.end - lastSelection.start;
            var shouldSlice = pendingBackspace && lastSelectionLength > 0 && selectionEnd === value.length && selectionEnd !== 0 && value.length > 0;
            if (shouldSlice) {
                value = value.slice(0, -1);
            }
            pendingBackspace = false;
            this.props.onChange(value);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            return React.createElement('div', { key: this.props.key, className: 'selected-container' }, [React.createElement('input', {
                className: 'selected-input' + (this.props.hasArrowIcon ? ' has-arrow-icon' : ''),
                value: this.props.value,
                onChange: function onChange(e) {
                    return _this4.onChange(e);
                },
                spellCheck: false,
                key: 'input',
                ref: function ref(input) {
                    _this4.input = input;
                }
            }), getArrowIfNeeded(this.props)]);
        }
    }]);

    return SearchBox;
}(React.Component);

Option.displayName = 'Option';
Selected.displayName = 'Selected';
SearchBox.displayName = 'SearchBox';

module.exports = {
    Option: compose(Option),
    Selected: compose(Selected),
    SearchBox: compose(SearchBox)
};


// WEBPACK FOOTER //
// ./~/wix-base-ui/lib/controls/dropDownChildren.js